import * as React from 'react'
import StoryblokService from 'utils/storyblok-service'
import InfoBoxComponent from './InfoBox'

export const transformProps = (propsArg) => ({
  ...propsArg,
  content: StoryblokService?.client?.richTextResolver?.render(propsArg.content),
})
const InfoBox = (props) => <InfoBoxComponent {...transformProps(props)} />

export default InfoBox
